import {HttpGetUsersOptions, HttpInfiniteUsersResponse} from '@/features/users/http/users.http'
import {useGetInfiniteUsers} from '@/features/users/queries/useGetInfiniteUsers'
import {useInputSearch} from '@/hooks/useInputSearch'
import {UseInfiniteQueryOptions} from '@tanstack/react-query'
import {z} from 'zod'

export const useInfiniteUsersSearchableList = (
    promiseArgs: Omit<HttpGetUsersOptions['params'], 'page' | 'search'>,
    options?: Pick<UseInfiniteQueryOptions<z.infer<typeof HttpInfiniteUsersResponse>>, 'enabled'>
) => {
    const {searchValue, onSearch, onResetSearch} = useInputSearch()

    const query = useGetInfiniteUsers(
        {
            ...promiseArgs,
            search: searchValue
        },
        options
    )

    return {
        ...query,
        remappedData: query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : [],
        searchValue,
        onResetSearch,
        onSearch
    }
}
